var _rect, _rect2, _rect3, _g, _path, _rect4, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessoriesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.96 43.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Accessories") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 2,
    height: 26.92,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 2,
    height: 26.92,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 2,
    height: 26.92,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73,38.66a1.72,1.72,0,0,1,.92.37c.4.37.76.7,1.08,1V31H71v2h2Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,60a1.71,1.71,0,0,1-.31-1H37V33h2V31H35V61H53.79A11,11,0,0,1,52.9,60Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.09,36.54a1.58,1.58,0,0,1,.58,1.09l.41,2.68.62.26.3-.23V21H68V36.49Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 2,
    height: 15.17,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.27,40.58c.2-.1.41-.18.61-.26a26.16,26.16,0,0,1,.48-2.9,1.61,1.61,0,0,1,.64-1V21H60V40.37Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.17,38.62a1.74,1.74,0,0,1,.83.25V21H56V39.1A1.92,1.92,0,0,1,57.17,38.62Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54,47V45.74c-.33-.43-.68-.88-1.09-1.37a1.69,1.69,0,0,1-.42-1.08,1.79,1.79,0,0,1,.34-1A13,13,0,0,1,54,41V21H52V47.34Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.47,56a6.76,6.76,0,0,1-.33-.8l-2.72-.4a1.54,1.54,0,0,1-1-.61,1.67,1.67,0,0,1-.35-1V50H40v6H54.43Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65,44.12a7,7,0,1,0,7,7A7,7,0,0,0,65,44.12Zm4.21,7.36a.53.53,0,0,1-.53.53H65.9v2.82a.52.52,0,0,1-.53.53h-.53a.52.52,0,0,1-.53-.53V52H61.53a.53.53,0,0,1-.53-.53V51a.53.53,0,0,1,.53-.53h2.78V47.68a.53.53,0,0,1,.53-.53h.53a.53.53,0,0,1,.53.53V50.5h2.78a.53.53,0,0,1,.53.53Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.14,54l.2-.57L78,52.9V49.43l-3.62-.55-.19-.6a9.19,9.19,0,0,0-.68-1.62l-.28-.54.36-.5c.22-.32.56-.75,1-1.32s.6-.76.78-1a28.89,28.89,0,0,0-2.53-2.57l-2.89,2.19-.56-.29A9.83,9.83,0,0,0,67.87,42l-.58-.2-.56-3.64H63.24c-.1.48-.25,1.37-.45,3l-.07.64-.62.2a9.19,9.19,0,0,0-1.49.62l-.57.3-2.86-2.22a11.68,11.68,0,0,0-1,.92c-.72.71-1.24,1.27-1.55,1.65.76.92,1.37,1.72,1.84,2.38l.36.51-.3.55a7.83,7.83,0,0,0-.63,1.48l-.19.6L52,49.35v3.47l3.64.54.17.62a8.54,8.54,0,0,0,.67,1.6l.3.55-.37.5c-.22.32-.56.76-1,1.32s-.6.77-.78,1a23.91,23.91,0,0,0,2.55,2.56l2.87-2.18.56.28a9.82,9.82,0,0,0,1.49.62l.59.19.55,3.64h3.49c.1-.48.25-1.36.45-3l.07-.64.61-.2a8.3,8.3,0,0,0,1.5-.62l.57-.3,2.85,2.23a11.21,11.21,0,0,0,1-.92A22.75,22.75,0,0,0,75.4,59c-.82-1-1.42-1.79-1.84-2.39l-.35-.5.29-.55A11.42,11.42,0,0,0,74.14,54ZM65,58a6.87,6.87,0,1,1,6.86-6.86A6.87,6.87,0,0,1,65,58Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessoriesDefault);
export default __webpack_public_path__ + "static/media/accessories-default.4dc1472a51408d0b9cd5a09568f8022b.svg";
export { ForwardRef as ReactComponent };